import httpRequest from "../utils/axios.js"
import config from "./config.js"
import { clear, push, alert, getItem, successSync } from "utils/defaultData"
import { retryClaimWeChatRedPacketClaimApi } from "api/onLine";

/*global wx WeixinJSBridge */

/**
 * 微信授权
 * apilist ['调用接口名']
 * [
  'openLocation',
  'getLocation',
  'chooseImage',
  'uploadImage',
  'hideOptionMenu',
  'openAddress'
]
 */

// 隐藏微信浏览器的复制功能
export function hideMenu() {
  function onBridgeReady() {
    WeixinJSBridge.call("hideOptionMenu")
  }
  if (typeof WeixinJSBridge == "undefined") {
    if (document.addEventListener) {
      document.addEventListener("WeixinJSBridgeReady", onBridgeReady, false)
    } else if (document.attachEvent) {
      document.attachEvent("WeixinJSBridgeReady", onBridgeReady)
      document.attachEvent("onWeixinJSBridgeReady", onBridgeReady)
    }
  } else {
    onBridgeReady()
  }
}
const hideCopyMenuNew = () => {
  wx.ready(function() {
    wx.hideMenuItems({
      menuList: ["menuItem:copyUrl"], // 要隐藏的菜单项，只能隐藏“传播类”和“保护类”按钮，所有menu项见附录3
    })
  })
}
/**
 * 通过config接口注入权限验证配置
 * @param {*} apiList 需要使用的JS接口列表
 */
export function wechatAuth(apiList, readyFunction) {
  var url = config.getticket
  var isiOS = !! navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
  var jsondata = {
    // url: location.href.split("#")[0]
    url: isiOS ? window.entryUrl : location.href.split("#")[0]
  }
  httpRequest
    .fetchGet(url, jsondata)
    .then(({ status, data }) => {
      if (status == 200) {
        wx.config({
          debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          appId: data.appId, // 必填，公众号的唯一标识
          timestamp: data.timestamp, // 必填，生成签名的时间戳
          nonceStr: data.nonceStr, // 必填，生成签名的随机串
          signature: data.signature, // 必填，签名
          jsApiList: apiList, // 必填，需要使用的JS接口列表
        })
        wx.error(function() {})
        wx.ready(() => {
          if (readyFunction) {
            readyFunction()
          }
        })
      }
    })
    .catch((err) => {
      console.log(err)
    })
}
/**
 * 微信支付
 */
export function wechatPay(signParams) {
  clear()
  if (signParams == "") {
    alert("发起支付失败，请稍后再试！", "提示", () => {
      push({
        path: "/orders?type=-1",
      })
    })
  }
  function onBridgeReady() {
    signParams.package = signParams.info
    signParams.signType = "RSA"
    WeixinJSBridge.invoke("getBrandWCPayRequest", signParams, function(res) {
      console.log("WeixinJSBridge.invoke output", res)
      if (res.err_msg === "get_brand_wcpay_request:ok") {
        if (location.href.indexOf("orders") < 0) {
          successSync("支付成功", () => {
            push({
              path: "/orders?type=-1",
            })
          })
        } else {
          successSync("支付成功", () => {
            location.reload()
          })
        }
      } else {
        alert("支付已被取消，请在12小时内完成支付！", "提示", "", () => {
          if (location.href.indexOf("orders") < 0) {
            push({
              path: "/orders?type=-1",
            })
          }
        })
      } // 使用以上方式判断前端返回,微信团队郑重提示：res.err_msg将在用户支付成功后返回    ok，但并不保证它绝对可靠。
    })
  }
  if (typeof WeixinJSBridge === "undefined") {
    if (document.addEventListener) {
      document.addEventListener("WeixinJSBridgeReady", onBridgeReady, false)
    } else if (document.attachEvent) {
      document.attachEvent("WeixinJSBridgeReady", onBridgeReady)
      document.attachEvent("onWeixinJSBridgeReady", onBridgeReady)
    }
  } else {
    onBridgeReady()
  }
}
// 获取地理位置
export function getLocation(successCallback, errorCallback) {
  wx.ready(function() {
    wx.getLocation({
      type: "gcj02", // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
      success: (res) => {
        successCallback(res)
      },
      fail: (error) => {
        errorCallback(error)
      },
      cancel: (error) => {
        errorCallback(error)
      },
    })
  })
}
// 使用微信内置地图查看位置接口
export function openLocation(data) {
  wx.ready(function() {
    wx.openLocation({
      scale: 18, // 地图缩放级别,整形值,范围从1~28。默认为最大
      ...data,
      latitude: parseFloat(data.latitude), // 类型为数字类型
      longitude: parseFloat(data.longitude),
    })
  })
}
// 上传图片
const uploadImage = (callback) => {
  wx.ready(function() {
    wx.chooseImage({
      count: 1, // 默认9
      sizeType: ["original", "compressed"], // 可以指定是原图还是压缩图，默认二者都有
      sourceType: ["album", "camera"], // 可以指定来源是相册还是相机，默认二者都有
      success: function(res) {
        var localIds = res.localIds // 返回选定照片的本地ID列表，localId可以作为img标签的src属性显示图片
        wx.uploadImage({
          localId: localIds[0], // 需要上传的图片的本地ID，由chooseImage接口获得
          isShowProgressTips: 1, // 默认为1，显示进度提示
          success: function(res) {
            let json = {}
            var serverId = res.serverId // 返回图片的服务器端ID
            json["serverId"] = serverId
            json["url"] = localIds[0]
            callback(json)
          },
          fail: function(res) {
            console.log(res)
          },
        })
      },
      fail: function(res) {
        console.log(res)
      },
    })
  })
}
// 仅在微信端可以访问
const onlyWeixin = () => {
  function addElementDiv() {
    var parent = document.body
    var div = document.createElement("div")
    div.setAttribute("class", "only_wx")
    div.innerHTML = "请使用微信打开"
    parent.appendChild(div)
  }
  // console.log(navigator.userAgent);
  var ua = navigator.userAgent.toLowerCase()
  if (ua.match(/MicroMessenger/i) != "micromessenger") {
    //不是微信浏览器
    let app = document.getElementById("app")
    document.body.removeChild(app)
    addElementDiv()
    return 0
  } else {
    return 1
  }
}
// 关闭微信浏览器
export function closeBrowser() {
  // 已过期，可使用新的jssdk进行替换 https://developers.weixin.qq.com/doc/offiaccount/OA_Web_Apps/JS-SDK.html#
  // eslint-disable-next-line no-undef
  WeixinJSBridge.call("closeWindow")
  // wx.closeWindow();
}

//获取微信配置信息--跳转小程序、获取定位信息
export function getWxApplets() {
  // var that = this;
  var url = config.jsapi
  var jsondata = {
    act: "getticket",
    url: document.URL,
  }
  //调用微信方法跳转小程序

  httpRequest
    .fetchGet(url, jsondata)
    .then((res) => {
      if (res.status == 1) {
        wx.config({
          debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          appId: getItem("appId"), // 必填，公众号的唯一标识
          timestamp: res.data.timestamp, // 必填，生成签名的时间戳
          nonceStr: res.data.nonce_str, // 必填，生成签名的随机串
          signature: res.data.signature, // 必填，签名
          jsApiList: ["wx-open-launch-weapp"], // 必填，需要使用的JS接口列表
          openTagList: ["wx-open-launch-weapp"], //打开的标签名
        })
        return 1
      } else {
        return 2
      }
    })
    .catch((err) => {
      console.log(err)
    })
}

//佣金保 微信JSAPI调起用户确认收款
export function claimRedEnvelope(mchId, packageInfo, orderNo) {

  var url = config.getticket
  var isiOS = !! navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
  var jsondata = {
  url: isiOS ? window.entryUrl : location.href.split("#")[0]
  }
  httpRequest
  .fetchGet(url, jsondata)
  .then(({ status, data }) => {
    if (status == 200) {
      wx.config({
        debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
        appId: data.appId, // 必填，公众号的唯一标识
        timestamp: data.timestamp, // 必填，生成签名的时间戳
        nonceStr: data.nonceStr, // 必填，生成签名的随机串
        signature: data.signature, // 必填，签名
        jsApiList: ['requestMerchantTransfer'], // 必填，需要使用的JS接口列表
      })
      wx.error(function() {})
      wx.ready(function () {
        wx.checkJsApi({
          jsApiList: ['requestMerchantTransfer'],
          success: function (res) {
            if (res.checkResult['requestMerchantTransfer']) {
              WeixinJSBridge.invoke('requestMerchantTransfer', {
                  mchId: mchId,
                  appId: data.appId,
                  package: packageInfo,
                },
                function (res) {
                  if(res.err_msg != "requestMerchantTransfer:cancel"){
                    retryClaimWeChatRedPacketClaimApi(orderNo)
                  }
                  if (res.err_msg == "requestMerchantTransfer:ok") {
                    this.$successSync('兑换成功' + JSON.stringify(res), () => {
                      this.$push({ path: "/coupons" });
                    });
                    // res.err_msg将在页面展示成功后返回应用时返回success，并不代表付款成功
                  }else {
                    push({ path: "/orders?type=-1"})
                  }
                }
              );
            } else {
              alert('你的微信版本过低，请更新至最新版本。');
            }
          }
        });
      });
    }
  })
  .catch((err) => {
    console.log(err)
  })
}

export default {
  wechatPay,
  wechatAuth,
  onlyWeixin,
  closeBrowser,
  getLocation,
  openLocation,
  uploadImage,
  hideMenu,
  hideCopyMenuNew,
  getWxApplets,
}